export const ALLOWED_MAX_DISK_SIZE = 16384;
export const DOWNLOAD_PERMISSION = "download";
export const ORG_WORKFLOWS_PATH = "/organization/workflows";
export const ORG_WORKFLOW_TEMPLATES_PATH = "/organization/workflow-templates";
export const ORG_USERS_PATH = "/organization/users";
export const ORG_DISKS_PATH = "/organization/disks";
export const ORG_INSTANCE_TYPES_PATH = "/organization/instance-types";
export const ORG_BLUEPRINTS_PATH = "/organization/workflow/blueprints";
export const ORG_USER_GROUPS_PATH = "/organization/user-groups";
export const ORG_CONTACT_PATH = "/organization/contact";
export const ORG_WORKFLOW_CONFIG_PATH = "/organization/workflowconfig";
export const ORG_AWS_CREDENTIALS_PATH = "/organization/awscredentials";
export const ORG_AWS_NETWORK_PATH = "/organization/awsnetwork";
export const ORG_LICENSES_PATH = "/organization/licenses";
export const ORG_ACCOUNT_INFO_PATH = "/organization/accountinfo";
export const ORG_FEATURES_PATH = "/organization/features";
